import React from "react";

const Stepper = ({ stepState, previousPage, nextPage }) => {
  return (
    <div className="row">
      <div className="col-6">
        {stepState.step > 0 && (
          <button className="btn btn-outline-secondary" onClick={previousPage}>
            Povratak
          </button>
        )}
      </div>

      <div className="col-6 text-right">
        {stepState.step < 7 && (
          <button className="btn btn-primary" onClick={nextPage}>
            Sljedeći korak
          </button>
        )}
      </div>
    </div>
  );
};

export default Stepper;
